import { BaseEntityModel } from '@/modules/core/app/models/abstracts/BaseEntityModel';
import { FeedbackType } from '@/modules/feedback/constants/FeedbackType';
import { User } from '@/modules/user/models/User';

export class Feedback extends BaseEntityModel {
  id?: string;
  modelType?: string;
  modelId?: number;
  type?: FeedbackType;
  value?: number;
  description?: string;
  createdByUserId?: number;
  createdByUser?: Relationship<User | null>;

  constructor(model: Partial<Feedback> = {}) {
    super(model);

    this.id = model.id;
    this.modelType = model.modelType;
    this.modelId = model.modelId;
    this.type = model.type;
    this.value = model.value;
    this.description = model.description;
    this.createdByUserId = model.createdByUserId;
    this.createdByUser = User.mapModelOrNull(model.createdByUser);
  }

  get isLiked(): boolean {
    return this.value === 1;
  }
}
